export default __webpack_public_path__ + "static/media/main_area2.68af7beb.png";